import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home.routing.module';
import { HomepanelComponent } from './homepanel/homepanel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [HomeComponent, HomepanelComponent],
  imports: [
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    AutoCompleteModule,
    CalendarModule,
    RadioButtonModule,
    OverlayPanelModule,
    InputSwitchModule,
    CommonModule
  ],
  exports:[
    HomeComponent, HomepanelComponent
  ]
})
export class HomeModule { }
